import { Pill } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { HUB_URL } from '@/lib/clerkSso';
import { useLancerDemo } from '@/api/platform';

/**
 * LOT_DEMO — accueil d'un commercial tant qu'aucune démo n'est ouverte.
 * Il n'a accès à rien d'autre : la démo est une copie neuve, jetée à la sortie.
 */
export default function DemoLaunchPage() {
  const lancer = useLancerDemo();

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-xl">
        <div className="flex items-center gap-2.5 mb-8">
          <div className="w-9 h-9 rounded-lg bg-accent flex items-center justify-center">
            <Pill size={18} color="#fff" strokeWidth={2.25} />
          </div>
          <div className="text-[15px] font-semibold text-slate-900">Officina · PharmaRH</div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
          <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-accent mb-2">Démonstration</div>
          <h1 className="text-2xl font-semibold text-slate-900 mb-4">Pharmacie du Bourg</h1>
          <p className="text-[14px] text-slate-600 leading-relaxed">
            Une officine complète : son équipe, son planning sur plusieurs mois, les demandes, la fiche navette.
            Modifiez un horaire, validez une semaine, posez un rendez-vous : tout fonctionne comme chez un client.
          </p>
          <p className="text-[14px] text-slate-600 leading-relaxed mt-3">
            <strong className="text-slate-900">Rien n'est conservé.</strong> Chaque démo repart d'une copie neuve,
            effacée quand vous la quittez.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Button variant="primary" size="lg" loading={lancer.isPending} onClick={() => lancer.mutate()}>
              {lancer.isPending ? 'Préparation de la démo…' : 'Lancer la démo'}
            </Button>
            <a href={`${HUB_URL}/commercial`} className="text-[13px] text-slate-600 hover:text-slate-900">
              Retour à mon espace
            </a>
          </div>
          {lancer.isError && <p className="text-[13px] text-danger mt-4">{(lancer.error as Error).message}</p>}
        </div>
      </div>
    </div>
  );
}
